/**
 * Activity – inspection, repair, service log (per PRD §6)
 */

import { ClipboardList, Wrench, Truck, Banknote } from 'lucide-react';

export default function Activity() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Activity</h1>
        <p className="text-muted-foreground">Inspection, repair, service log for mobile units and ATMs</p>
      </div>

      <div className="rounded-xl border bg-card p-8 text-center">
        <ClipboardList className="h-12 w-12 text-muted-foreground mx-auto mb-3" />
        <p className="text-muted-foreground">Activity log – coming soon.</p>
        <p className="text-xs text-muted-foreground mt-2">
          Field ops will log activity (inspection, repair, service) for mobile units and ATMs; same backend as Ketchup Portal.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="rounded-xl border bg-card p-6 flex items-center gap-4">
          <Truck className="h-10 w-10 text-primary" />
          <div>
            <p className="font-medium">Mobile unit activity</p>
            <p className="text-sm text-muted-foreground">Log from Mobile Units page</p>
          </div>
        </div>
        <div className="rounded-xl border bg-card p-6 flex items-center gap-4">
          <Banknote className="h-10 w-10 text-primary" />
          <div>
            <p className="font-medium">ATM maintenance</p>
            <p className="text-sm text-muted-foreground">Log from ATMs page</p>
          </div>
        </div>
      </div>
    </div>
  );
}
